/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemSingleSelectionErrorMessage } from './formPagePropertyItemSingleSelectionErrorMessage';
import { FormPagePropertyItemSingleSelectionPropertyItem } from './formPagePropertyItemSingleSelectionPropertyItem';
import { FormPagePropertyItemSingleSelectionDrillDownSetting } from './formPagePropertyItemSingleSelectionDrillDownSetting';
import { FormPagePropertyItemSingleSelectionInputFormat } from './formPagePropertyItemSingleSelectionInputFormat';
import { FormPagePropertyItemSingleSelectionCandidate } from './formPagePropertyItemSingleSelectionCandidate';
import { FormPagePropertyItemSelectionRequiredSubtext } from './formPagePropertyItemSelectionRequiredSubtext';
import { FormPagePropertyItemSelectionRegistrationLimitSetting } from './formPagePropertyItemSelectionRegistrationLimitSetting';


export interface FormPagePropertyItemSingleSelectionAllOf { 
    type: FormPagePropertyItemSingleSelectionAllOf.TypeEnum;
    properties: FormPagePropertyItemSingleSelectionPropertyItem;
    inputFormat: FormPagePropertyItemSingleSelectionInputFormat;
    candidates: Array<FormPagePropertyItemSingleSelectionCandidate>;
    errorMessage?: FormPagePropertyItemSingleSelectionErrorMessage;
    /**
     * 補助テキストが必須となる選択肢と、選択肢ごとのエラーメッセージの配列. 補助テキストの必須判定に利用
     */
    requiredSubtext?: Array<FormPagePropertyItemSelectionRequiredSubtext>;
    drillDown?: FormPagePropertyItemSingleSelectionDrillDownSetting;
    registrationLimit?: FormPagePropertyItemSelectionRegistrationLimitSetting;
    /**
     * この単一選択型が必須の場合に、固定値 value が入る
     */
    required?: Array<string>;
}
export namespace FormPagePropertyItemSingleSelectionAllOf {
    export type TypeEnum = 'object';
    export const TypeEnum = {
        Object: 'object' as TypeEnum
    };
}



